import { render, staticRenderFns } from "./ChartLegendTable.vue?vue&type=template&id=1cacafd8&scoped=true&"
import script from "./ChartLegendTable.vue?vue&type=script&lang=ts&"
export * from "./ChartLegendTable.vue?vue&type=script&lang=ts&"
import style0 from "./ChartLegendTable.vue?vue&type=style&index=0&id=1cacafd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cacafd8",
  null
  
)

export default component.exports